import React, { useEffect, useState } from "react";
import "./ThreeDotSlider.scss";
import quote from "../../assets/testimonial-quote.svg.svg";

const ThreeDotSlider = ({ slides }) => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setIndex((prev) => (prev + 1) % slides.length);
        }, 3000);
        return () => clearInterval(timer);
    }, [slides.length]);

    return (
        <div className="testi-slider">
            <div
                className="testi-slides"
                style={{ transform: `translateX(-${index * 100}%)` }}
            >
                {slides.map((data, key) => (
                    <div key={key} className="testi-slides-Item">
                        <img alt="" src={quote} className="testi-slides-Item-symb" />
                        <div className="testi-slides-Item-content">{data.review}</div>
                        <img alt="" src={data.src} className="testi-slides-Item-img" />
                        <div className="testi-slides-Item-name">{data.name}</div>
                    </div>
                ))}
            </div>

            {slides.length > 1 && <div className="testi-dots">
                {slides.map((_, i) => (
                    <button
                        key={i}
                        className={`testi-dot ${i === index ? "active" : ""}`}
                        onClick={() => setIndex(i)}
                    />
                ))}
            </div>}
        </div>
    );
};

export default ThreeDotSlider;
